// removed by extract-text-webpack-plugin
module.exports = {"container":"_2TQH","reviewus":"_3VlW","img":"NhO6","trustyou":"_2SKI","inner":"_1DzH","block":"_3a9s"};


//////////////////
// WEBPACK FOOTER
// ./src/components/homescreen/reviewus/style.css
// module id = 357
// module chunks = 9